<template>
  <Teleport to="body">
    <div>
      <button
          v-show="showButton"
          @click="scrollToTop"
          class="scroll-to-top__button q-shadow-sm"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 4L16 12L8 20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"></path>
        </svg>

      </button>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import {ref, onMounted, onUnmounted} from 'vue'


const showButton = ref(false)

const handleScroll = () => {
  showButton.value = window.scrollY > 500
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style>
.scroll-to-top__button {
  transform: rotate(-90deg);
  display: block;
}

.scroll-to-top__button {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background-color: #fff;
  color: #333;
  border: none;
  cursor: pointer;
  border-radius: 50px;
  transition: opacity 1s ease;
  z-index: 999999;
  width: 50px;
  height: 50px;
}

.scroll-to-top__button:hover {
  background-color: #e6e6e6;
}
</style>
